export const cartItemsSelector = (state) => state.cartReducer.items;
export const totalCartItemsSelector = (state) => state
  .cartReducer.items
  .reduce((acc, item) => acc + item.quantity, 0);
export const cartStoreSelector = (state) => state.cartReducer.store;
export const showAddToCartTooltipSelector = (state) => state.cartReducer.showAddToCartTooltip;
export const cartZendeskIdSelector = (state) => state.cartReducer.zendeskConfirmationId;
export const userPiDataSelector = (state) => state.cartReducer.userPiData;
